export const SOCIAL_MEDIA_LINKS = {
    facebook: "https://www.facebook.com/groups/livespainvisa/",
    linkedin: "https://www.linkedin.com/company/livespainvisa-consulting/?viewAsMember=true",
    instagram: "https://www.instagram.com/livespainvisa?igsh=MW92eGwyNXBpMmFvaQ==",
};
